"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DISABLED_TEXT_COLOR = void 0;
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
const DISABLED_TEXT_COLOR = exports.DISABLED_TEXT_COLOR = (0, _utils.token)('color.link.neutral-disabled');